<ion-input name="currency-internal-input" mask="separator.2" #input [type]="isBlur ? 'text' : 'number'" inputmode="number" (ionFocus)="onFocus($event)" (ionBlur)="onBlur($event)"
[(ngModel)]="isBlur ? valueFormatted : value" value="0.00" step='0.01' [placeholder]="placeholder" [disabled]="disabled" id="currency-input"
[ngStyle]="{'width': width + '% !important' }" [ngClass]="{'field-changed': fieldChanged}"></ion-input>

